var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voice-commands"},_vm._l((_vm.$props.commands),function(command,i){return _c('div',{key:i,staticClass:"voice-command"},[_c('font-awesome-icon',{staticStyle:{"padding-right":"4px"},attrs:{"icon":['fas', 'microphone']}}),_c('div',[_vm._v("\""+_vm._s(command)+"\"")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }